export const textVariants = {
  startAnimation: {
    y: 30,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 0.3,
    },
  },
};

export const textVariantsWithoutTransition = {
  startAnimation: {
    y: 30,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
  },
};

export const imgVariants = {
  startAnimation: {
    y: -50,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
  },
};

export const saleVariants = {
  startAnimation: {
    x: "-90vw",
  },
  endAnimation: {
    x: "100vw",
    transition: {
      repeat: Infinity,
      repeatType: "loop",
      duration: 20,
    },
  },
};

export const staggerChildrenVariants = {
  startAnimation: {
    opacity: 0,
  },
  endAnimation: {
    when: "beforeChildren",
    opacity: 1,
    transition: {
      staggerChildren: 1,
    },
  },
};

export const staggerPackagesVariants = {
  startAnimation: {},
  endAnimation: {
    when: "beforeChildren",
    transition: {
      staggerChildren: 1,
    },
  },
};

export const staggerVariants = {
  startAnimation: {
    y: 100,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: "easeInOut",
      when: "beforeChildren",
      staggerChildren: 0.3,
    },
  },
};

export const leftVariants = {
  startAnimation: {
    x: -100,
    opacity: 0,
  },
  endAnimation: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
    },
  },
};

export const leftVariants2 = {
  startAnimation: {
    x: -100,
    opacity: 0,
  },
  endAnimation: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 0.5,
    },
  },
};

export const rightVariants = {
  startAnimation: {
    x: 100,
    opacity: 0,
  },
  endAnimation: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
    },
  },
};

export const rightVariants2 = {
  startAnimation: {
    x: 100,
    opacity: 0,
  },
  endAnimation: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 1,
    },
  },
};

export const downVariants = {
  startAnimation: {
    y: 100,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 0.7,
    },
  },
};

export const downVariants2 = {
  startAnimation: {
    y: 100,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 1.5,
    },
  },
};

export const topVariants = {
  startAnimation: {
    y: -100,
    opacity: 0,
  },
  endAnimation: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 0.7,
    },
  },
};
